<main id="main">
    <section class="academy academy-thank-you-section thankyou">
        <div class="container aos-init aos-animate">
            <div class="row">
                <div class="col-md-12 quiz-main-body">
                    <div class="content">
                        <div class="container-fluid">

                            <div class="col-md-12">
                                <div class="jumbotron text-center">
                                    <div class="Thank-you-gif">
                                        <img src="assets/img/players/output-onlinegiftools.gif" alt="">
                                    </div>
                                    <h1 class="display-6 mb-0 mt-6">Thank You!!</h1>
                                    <p class="lead" style="margin-bottom: 10px;
                                    font-weight: 400;"><strong>Your KYC was successfully submitted.!
                                        </strong>
                                    </p>
                                    <hr>
                                    <p> You will be notified once admin approve it.
                                    </p>
                                    <button> <a href="/profile-info" style="color: #34c759;">Back to
                                            profile</a></button>
                                </div>
                            </div>
                        </div> <!-- ENd of container fluid -->

                    </div>
                </div>
            </div>
        </div>
    </section>
</main>